/* eslint-disable react/jsx-key */
/* eslint-disable react/prop-types */
import { Map as ImmutableMap } from 'immutable';
//
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import ThreeDotIcon from '@mui/icons-material/MoreVert';

// import { datasetsTypes } from 'app-components/flux/datasets';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import { sharesActions, sharesTypes } from 'app-components/flux/shares';

import {
  DIALOG_TYPE as CONFIRMATION_DIALOG_TYPE,
  mkConfirmationDialogProps,
} from 'components/Dialogs/ConfirmationDialog';

// type Props = {
//   dataset: datasetsTypes.Dataset,
//   share: ?any;
// }

const ManageSharesMenu = (props) => {
  const { dataset, share } = props;
  const dispatch = useDispatch();

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);

  const handleOpenMenu = (event) => setMenuAnchorEl(event.currentTarget);
  const handleCloseMenu = () => setMenuAnchorEl(null);

  const handleDeleteShare = () => {
    handleCloseMenu();
    dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: 'delete-share',
          type: CONFIRMATION_DIALOG_TYPE,
          props: ImmutableMap(
            mkConfirmationDialogProps({
              title: 'Remove',
              content: `After removing, ${share.granteeFirstName} ${share.granteeLastName} will no longer have access to this space.`,
              confirmLabel: 'Continue',
              denyLabel: 'Cancel',
              confirmAction: () => dispatch(sharesActions.deleteShare(share)),
            }),
          ),
        }),
      ),
    );
  };

  const handleResendInvitation = () => {
    handleCloseMenu();
    const invite = sharesTypes.mkShare({
      id: share.id,
      state: 'INVITED',
    });
    dispatch(sharesActions.updateShare(invite));
  };

  const handleRevokeInvitation = () => {
    handleCloseMenu();
    dispatch(
      rootUiActions.createDialog(
        rootUiTypes.mkRootUiData({
          id: 'revoke-invitation',
          type: CONFIRMATION_DIALOG_TYPE,
          props: ImmutableMap(
            mkConfirmationDialogProps({
              title: 'Revoke invitation',
              content: `After revoking, ${share.granteeFirstName} ${share.granteeLastName} will no longer be able to accept and access this space.`,
              confirmLabel: 'Continue',
              denyLabel: 'Cancel',
              confirmAction: () => {
                const revoke = sharesTypes.mkShare({
                  id: share.id,
                  state: 'INACTIVE',
                });
                dispatch(sharesActions.updateShare(revoke));
              },
            }),
          ),
        }),
      ),
    );
  };

  const renderActiveShareMenuItems = () => <MenuItem onClick={handleDeleteShare}>Remove</MenuItem>;

  const renderInviteShareMenuItems = () => [
    <MenuItem onClick={handleResendInvitation}>Resend invitation</MenuItem>,
    <Divider />,
    share.expired ? (
      <MenuItem onClick={() => dispatch(sharesActions.deleteShare(share))}>Remove</MenuItem>
    ) : (
      <MenuItem onClick={handleRevokeInvitation}>Revoke invitation</MenuItem>
    ),
  ];

  const renderRevokedMenuItems = () => [
    <MenuItem onClick={handleResendInvitation}>Resend invitation</MenuItem>,
    <Divider />,
    <MenuItem onClick={handleDeleteShare}>Remove</MenuItem>,
  ];

  return (
    <>
      <IconButton id={`manage-shares-menu-button-${dataset.id}`} onClick={handleOpenMenu} size='large'>
        <ThreeDotIcon />
      </IconButton>
      <Menu
        id={`manage-shares-menu-${dataset.id}`}
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleCloseMenu}
      >
        {share.state === 'INVITED' && renderInviteShareMenuItems()}
        {share.state === 'ACTIVE' && renderActiveShareMenuItems()}
        {(share.state === 'INACTIVE' || share.state === 'ABANDONED') && renderRevokedMenuItems()}
      </Menu>
    </>
  );
};

export default ManageSharesMenu;
